(() => {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const ns = 'http://www.w3.org/2000/svg';
  const webSound = new Audio('https://cdn.shopify.com/s/files/1/0681/0029/2665/files/sjbjj-web-thwip.mp3?v=1792378282');
  webSound.preload = 'auto';
  webSound.volume = 0.75;
  const soundCountKey = 'sjbjjWebSoundClicks';
  let soundCount = 0;
  try { soundCount = Math.min(2, Number(window.sessionStorage.getItem(soundCountKey)) || 0); } catch {}
  function playWebSound() {
    if (window.matchMedia('(max-width: 767px), (pointer: coarse)').matches || soundCount >= 2) return;
    soundCount += 1;
    try { window.sessionStorage.setItem(soundCountKey, String(soundCount)); } catch {}
    try {
      webSound.pause();
      webSound.currentTime = 0.18;
      const playback = webSound.play();
      if (playback && typeof playback.catch === 'function') playback.catch(() => {});
    } catch (error) { console.debug('Web sound unavailable', error); }
  }
  let active = null;
  let cleanupTimer = 0;
  let controlAnimation = null;
  let frame = 0;
  let revealFrame = 0;
  let navigationTimer = 0;
  let navigationPending = false;
  function clearEffect() {
    window.clearTimeout(cleanupTimer);
    if (active) active.remove();
    active = null;
    window.cancelAnimationFrame(frame);
    window.cancelAnimationFrame(revealFrame);
    window.clearTimeout(navigationTimer);
    if (controlAnimation) controlAnimation.cancel();
    controlAnimation = null;
  }
  function path(parent, d, className) {
    const node = document.createElementNS(ns, 'path');
    node.setAttribute('d', d);
    node.setAttribute('class', className);
    node.setAttribute('pathLength', '1000');
    parent.append(node);
  }
  function shoot(x, y, large) {
    if (preference.matches || !document.body) return;
    clearEffect();
    const width = window.innerWidth;
    const height = window.innerHeight;
    x = Math.min(Math.max(x, 0), width);
    y = Math.min(Math.max(y, 0), height);
    const svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('class', 'sjbjj-web-shot' + (large ? ' sjbjj-web-shot--travel' : ''));
    svg.setAttribute('viewBox', '0 0 ' + width + ' ' + height);
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    const group = document.createElementNS(ns, 'g');
    svg.append(group);
    const anchorX = large ? width + 25 : x + 92;
    const anchorY = large ? -25 : y - 80;
    const length = Math.max(1, Math.hypot(x - anchorX, y - anchorY));
    const ux = (x - anchorX) / length;
    const uy = (y - anchorY) / length;
    const px = -uy;
    const py = ux;
    const neck = large ? .67 : .58;
    const fanWidth = large ? Math.min(86, length * .3) : 34;
    const point = (t, offset) => [anchorX + (x - anchorX) * t + px * offset, anchorY + (y - anchorY) * t + py * offset];
    const format = (p) => p.map(v => v.toFixed(2)).join(' ');
    const ropePath = (index, amplitude) => {
      let d = '';
      const steps = 36;
      for (let j = 0; j <= steps; j++) {
        const t = neck * j / steps;
        const taper = .4 + .6 * Math.sin(Math.PI * j / steps);
        const weave = Math.sin(j * .92 + index * 1.7) * amplitude * taper;
        const looseLoop = Math.sin(j * .37 + index) * amplitude * .6;
        const p = point(t, weave + looseLoop + (index - 3) * .55);
        d += (j === 0 ? 'M' : 'L') + format(p);
      }
      return d;
    };
    path(group, ropePath(3, 1), 'sjbjj-web-outline');
    path(group, ropePath(3, 1), 'sjbjj-web-strand sjbjj-web-core');
    for (let i = 0; i < 7; i++) {
      path(group, ropePath(i, 2.3 + (i % 3) * 1.8), 'sjbjj-web-strand sjbjj-web-fiber');
    }
    for (let i = 0; i < 3; i++) {
      const t = .13 + i * .16;
      const start = point(t, 1);
      const end = point(t + .13, -2);
      const loop = point(t + .07, (i % 2 ? -1 : 1) * (11 + i * 3));
      path(group, 'M' + format(start) + 'Q' + format(loop) + ' ' + format(end), 'sjbjj-web-strand sjbjj-web-fiber');
    }
    const fans = [];
    for (let i = 0; i < 13; i++) {
      const spread = (i - 6) / 6;
      const reach = 1 + Math.sin(i * 2.17) * .065;
      const offset = spread * fanWidth * (.84 + .16 * Math.cos(i * 1.8));
      const start = point(neck - .035 + (i % 3) * .012, (i - 6) * .5);
      const control1 = point(neck + .12, spread * fanWidth * .08);
      const control2 = point(.88, offset * .39);
      const end = point(reach, offset);
      path(group, 'M' + format(start) + 'C' + format(control1) + ' ' + format(control2) + ' ' + format(end), 'sjbjj-web-strand sjbjj-web-fan');
      fans.push({offset, reach});
    }
    for (let ring = 1; ring <= 5; ring++) {
      const progress = ring / 6;
      for (let i = 0; i < fans.length - 1; i++) {
        if ((i * 3 + ring * 5) % 7 === 0) continue;
        const t = neck + (fans[i].reach - neck) * progress;
        const nextT = neck + (fans[i + 1].reach - neck) * (progress + Math.sin(i + ring) * .025);
        const ease = progress * progress;
        const start = point(t, fans[i].offset * ease);
        const end = point(nextT, fans[i + 1].offset * ease);
        const sag = point((t + nextT) / 2 - .018, (fans[i].offset + fans[i + 1].offset) * ease / 2);
        path(group, 'M' + format(start) + 'Q' + format(sag) + ' ' + format(end), 'sjbjj-web-strand sjbjj-web-stitch');
      }
    }
    svg.dataset.anchorX = anchorX;
    svg.dataset.anchorY = anchorY;
    // Native SVG clipping uses the same viewBox coordinates as the strand.
    const revealWidth = fanWidth + 30;
    const defs = document.createElementNS(ns, 'defs');
    const clip = document.createElementNS(ns, 'clipPath');
    const clipId = 'sjbjj-web-reveal-' + Date.now().toString(36);
    clip.setAttribute('id', clipId);
    clip.setAttribute('clipPathUnits', 'userSpaceOnUse');
    const polygon = document.createElementNS(ns, 'polygon');
    const revealPoints = reach => [
      point(-.12, -revealWidth), point(-.12, revealWidth),
      point(reach, revealWidth), point(reach, -revealWidth)
    ].map(p => p.map(v => v.toFixed(2)).join(',')).join(' ');
    polygon.setAttribute('points', revealPoints(-.12));
    clip.append(polygon);
    defs.append(clip);
    svg.prepend(defs);
    group.setAttribute('clip-path', 'url(#' + clipId + ')');
    document.body.append(svg);
    active = svg;
    const revealStarted = performance.now();
    function reveal(now) {
      if (active !== svg) return;
      const progress = Math.min(1, Math.max(0, (now - revealStarted) / 210));
      const eased = 1 - Math.pow(1 - progress, 3);
      polygon.setAttribute('points', revealPoints(-.12 + 1.30 * eased));
      if (progress < 1) revealFrame = window.requestAnimationFrame(reveal);
      else {
        // Once fully revealed, remove the clip so it cannot hide the pull.
        group.removeAttribute('clip-path');
        defs.remove();
      }
    }
    revealFrame = window.requestAnimationFrame(reveal);
    if (!large) cleanupTimer = window.setTimeout(clearEffect, 760);
  }
  function pullControl(target, x, y, destination) {
    // Keep the real control in its layout, and keep the far end of the web fixed.
    const svg = active;
    const web = svg.querySelector('g');
    const anchorX = Number(svg.dataset.anchorX);
    const anchorY = Number(svg.dataset.anchorY);
    const rect = target.getBoundingClientRect();
    const hold = 300;
    const duration = 340;
    const travel = .34;
    const baseTransform = getComputedStyle(target).transform;
    const base = baseTransform === 'none' ? '' : baseTransform + ' ';
    const origin = (x - rect.left) + 'px ' + (y - rect.top) + 'px';
    const dx = (anchorX - x) * travel;
    const dy = (anchorY - y) * travel;
    controlAnimation = target.animate([
      {transform: 'translate(0px,0px) ' + base + 'scale(1)', transformOrigin: origin, opacity: 1},
      {transform: 'translate(' + (dx * .75) + 'px,' + (dy * .75) + 'px) ' + base + 'scale(.925)', transformOrigin: origin, opacity: 1, offset: .75},
      {transform: 'translate(' + dx + 'px,' + dy + 'px) ' + base + 'scale(.90)', transformOrigin: origin, opacity: 0}
    ], {duration, fill: 'both', easing: 'linear'});
    controlAnimation.pause();
    controlAnimation.currentTime = 0;
    const started = performance.now();
    // One frame clock controls both the attachment and the item.
    function tick(now) {
      if (active !== svg) return;
      const progress = Math.min(1, Math.max(0, (now - started - hold) / duration));
      const pull = progress * progress * (3 - 2 * progress);
      const dx = (anchorX - x) * travel * pull;
      const dy = (anchorY - y) * travel * pull;
      const scale = 1 - travel * pull;
      web.setAttribute('transform', 'translate(' + anchorX + ' ' + anchorY + ') scale(' + scale + ') translate(' + -anchorX + ' ' + -anchorY + ')');
      controlAnimation.currentTime = pull * duration;
      svg.style.opacity = String(1 - Math.max(0, (progress - .82) / .18));
      if (progress < 1) frame = window.requestAnimationFrame(tick);
      else {
        // Hold the final state while the browser loads; never snap back before navigation.
        window.location.assign(destination);
        navigationTimer = window.setTimeout(() => {
          navigationPending = false;
          clearEffect();
        }, 6000);
      }
    }
    frame = window.requestAnimationFrame(tick);
  }
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || preference.matches || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = event.target instanceof Element ? event.target.closest('a[href],button,summary,[role="button"]') : null;
    if (!target || target.closest('[data-no-web-effect]') || target.matches(':disabled,[aria-disabled="true"]') || target.closest('.shopify-payment-button,shopify-payment-terms')) return;
    if (navigationPending) { event.preventDefault(); return; }
    const rect = target.getBoundingClientRect();
    const arrow = target.querySelector('.icon-wrap,.icon-arrow,.icon-caret');
    const arrowRect = arrow ? arrow.getBoundingClientRect() : null;
    const x = arrowRect && arrowRect.width ? arrowRect.left + arrowRect.width / 2 : rect.right - Math.min(18, rect.width / 4);
    const y = arrowRect && arrowRect.height ? arrowRect.top + arrowRect.height / 2 : rect.top + rect.height / 2;
    const link = target.closest('a[href]');
    let destination = null;
    if (link && !link.hasAttribute('download') && (!link.target || link.target === '_self')) {
      try {
        const url = new URL(link.href, location.href);
        if (url.origin === location.origin && /^https?:$/.test(url.protocol) && (!url.hash || url.pathname + url.search !== location.pathname + location.search)) destination = url.href;
      } catch {}
    }
    const isShoppingAction = Boolean(target.closest('form[action*="/cart/add"], .product-form, .cart, .cart-drawer, [id*="checkout"], [class*="checkout"]') || target.matches('[name="add"],[name="checkout"],[type="submit"]') || (link && /\/(cart|checkout)(\/|\?|$)/i.test(link.href)));
    if (destination && !isShoppingAction) playWebSound();
    shoot(x, y, Boolean(destination));
    if (destination) {
      event.preventDefault();
      navigationPending = true;
      pullControl(target, x, y, destination);
    }
  }, {capture: true});
  window.addEventListener('pagehide', clearEffect);
  window.addEventListener('pageshow', (event) => { if (event.persisted) { navigationPending = false; clearEffect(); } });
  preference.addEventListener('change', () => { if (preference.matches) clearEffect(); });
})();